import { render, staticRenderFns } from "./Violenec.vue?vue&type=template&id=d141df20&"
import script from "./Violenec.vue?vue&type=script&lang=js&"
export * from "./Violenec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports